export const dateTypes = [
  {
    name: 'created',
    label: 'Дата создания'
  },
  {
    name: 'updated',
    label: 'Дата обновления'
  }
]

export const saleTypes = ['Наличный', 'Безналичный', 'Кредит']
export const paymentTypes = ['Кредит', 'Прямая']
export const creationTypes = [
  {
    name: 'Октелл',
    value: 'oktell'
  },
  {
    name: 'Сэо',
    value: 'seo'
  },
  {
    name: 'Менеджер',
    value: 'manager'
  }
]
